<template>
<div>
	<v-card height="600" class="mb-3 pt-3 px-1" flat 
			:color="darkTheme ? '#111111' : '#F1F1FF'" flat>
<!--         <v-toolbar color="indigo darken-3" dark height="40" class="amenitiesSearchToolbar">
            <v-toolbar-title width="100%" style="width: 100%;">
                <v-layout row align-center justify-space-between>
                    <v-flex class="subheading">Multi Attribute Search</v-flex>
                    <v-flex class="text-xs-right">
                    	<v-btn icon small style="transform: scale(.9);"><v-icon @click="setShowHelpRoomAmenities(true)">help</v-icon></v-btn>
                    </v-flex>
                </v-layout>                                 
            </v-toolbar-title>            
        </v-toolbar> -->
        
        <v-card-text>  

        	<v-select v-if="!selectedList"
		          :items="roomAttributes"
		          autofocus
		          item-text="label"
		          item-value="label"
		          label="Choose Room Attribute"
		          outline
		          return-object
		          @change=""
		          v-model="selectedAttribute">
	        </v-select>
	        <v-select v-if="selectedAttribute && selectedAttribute.operands "
		          :items="operands"
		          item-text="label"
		          item-value="value"
		          label="Select Operand"
		          outline
		          v-model="selectedOperand">		          	
		    </v-select>	
		    <v-layout v-if="selectedAttribute">
		    	<v-autocomplete v-if="selectedAttribute.label=='Condition'"
			    	autofocus
	                v-model="selectedSearchValue"
	                autocomplete
	                clearable  
	                :reset-value="null"                  
	                flat 
	                outline
	                single-line
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="conditions"
	                label="Condition"
	                hide-no-data
	                hide-details>
	            </v-autocomplete>
	            <v-autocomplete v-else-if="selectedAttribute.label=='Utilization'"
			    	autofocus
	                v-model="selectedSearchValue"
	                autocomplete
	                clearable  
	                :reset-value="null"                  
	                flat 
	                outline
	                single-line
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="utilizations"
	                label="Condition"
	                hide-no-data
	                hide-details>
	            </v-autocomplete>
	            <v-autocomplete v-else-if="selectedAttribute.label=='Suitability'"
			    	autofocus
	                v-model="selectedSearchValue"
	                autocomplete
	                clearable  
	                :reset-value="null"                  
	                flat 
	                outline
	                single-line
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="suitabilities"
	                label="Condition"
	                hide-no-data
	                hide-details>
	            </v-autocomplete>

			    <v-autocomplete v-else-if="selectedAttribute.label=='Category'"
			    	autofocus
	                v-model="selectedSearchValue"
	                autocomplete
	                clearable  
	                :reset-value="null"                  
	                flat 
	                outline
	                single-line
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="categories"
	                item-text="nameAndID"
	                item-value="categoryID"
	                label="Room Category"
	                hide-no-data
	                hide-details>
	            </v-autocomplete>

	            <v-autocomplete v-else-if="selectedAttribute.label=='Type'"
	                v-model="selectedSearchValue"
	                autofocus
	                autocomplete
	                single-line
	                clearable                    
	                flat 
	                outline
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="types"
	                item-text="nameAndID"
	                item-value="typeID"
	                label="Room Type"
	                hide-details>
	            </v-autocomplete>

	            <v-autocomplete v-else-if="selectedAttribute.label=='Use'"
	                v-model="selectedSearchValue"
	                autofocus
	                autocomplete
	                single-line
	                clearable                    
	                flat 
	                outline
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="uses"
	                item-text="nameAndID"
	                item-value="useID"
	                label="Room Use"
	                hide-details>
	            </v-autocomplete>

	            <v-autocomplete v-else-if="selectedAttribute.label=='Classification'"
	                v-model="selectedSearchValue"
	                autofocus
	                autocomplete
	                single-line
	                clearable                    
	                flat 
	                outline
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="classifications"
	                item-text="classificationName"
					item-value="classificationName"
	                label="Room Classification"
	                hide-details>
	            </v-autocomplete>

	            <v-autocomplete v-else-if="selectedAttribute.label=='Name'"
	                v-model="selectedSearchValue"
	                autofocus
	                autocomplete
	                single-line
	                clearable                    
	                flat 
	                outline
	                style="width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
	                :items="roomNames"
	                item-text="name"
                	item-value="name"
	                label="Room Name"
	                hide-details>
	            </v-autocomplete>

	            <v-autocomplete outline	v-else-if="selectedAttribute.label=='Building'"
					v-model="selectedSearchValue"						
					hide-no-data
					hide-details
					auto-select-first
					autocomplete
					clearable
					style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
					:items="buildings"
					:filter="customFilter"
					item-text="name"
                	item-value="bldgAlpha"
					label="Building Name / Number / Addr"
					single-line
					>
					<template
				        slot="selection"
				        slot-scope="{ item, tile }"
				      >
				      	<v-layout >
				        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
				        	{{item.bldgAlpha}}
				        </v-list-tile-avatar>
				        <v-list-tile-content>
				          <v-list-tile-title>
				          	{{item.name}}
				          </v-list-tile-title>
				          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
				        </v-list-tile-content>
				    	</v-layout>
				      </template>
					<template
				        slot="item"
				        slot-scope="{ item, tile }"
				      >
				        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
				        	{{item.bldgAlpha}}
				        </v-list-tile-avatar>
				        <v-list-tile-content>
				          <v-list-tile-title>
				          	{{item.name}}
				          </v-list-tile-title>
				          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
				        </v-list-tile-content>
				      </template>
				</v-autocomplete>

	            <AutocompleteCollege v-else-if="selectedAttribute.label=='College'" 	 
	             	style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"           	               
	                :outline=true     
	                v-on:return-selection="collegeAutoCompleteReturn" />

	            <AutocompleteDepartment v-else-if="selectedAttribute.label=='Department'" 
	             	style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"               
	                :outline=true     
	                v-on:return-selection="departmentAutoCompleteReturn" />	

	            <v-text-field v-else 
		          label="Enter Value"
		          autofocus
		          outline
		          v-model="selectedSearchValue">
		        </v-text-field>	            
		        
		        
	    	</v-layout>
	        
	        <span v-if="!selectedAttribute && !selectedList" class="ml-4"
	        	  style="position: relative; top: -15px;">OR
	        </span>

        	<v-form v-model="valid" ref="form" v-if="!selectedAttribute"    	>

				<v-select 
		          :items="listOfLists"
		          item-text="listname"
		          item-value="listname"
		          label="Choose Amenities List"
		          outline
		          clearable
		          return-object
		          @change="listChanged"
		          v-model="selectedList">
		        </v-select>

		        <v-select v-if="listDefinition && selectedList"
		          :items="listDefinition && listDefinition.list"
		          item-text="label"
		          item-value="label"
		          label="Select Amenity"
		          outline
		          return-object
		          v-model="selectedAmenity">
		          	<template slot="item" slot-scope="{ item, tile }">
				        <v-list-tile-content>
					        <v-list-tile-title>
					        	<v-layout row justify-space-between>
					        		<v-flex>{{item.label}}</v-flex>
					        		<v-flex class="caption text-xs-right">{{item.dataType}}</v-flex>
					        	</v-layout>
					        </v-list-tile-title>
				        </v-list-tile-content>
				    </template>
				    <template slot="selection" slot-scope="{ item, tile }">
				        <v-list-tile-content>
					        <v-list-tile-title>
					        	<v-layout row justify-space-between>
					        		<v-flex>{{item.label}}</v-flex>
					        		<v-flex class="caption text-xs-right">{{item.dataType}}</v-flex>
					        	</v-layout>
					        </v-list-tile-title>
				        </v-list-tile-content>
				    </template>
		        </v-select>	

		        <v-select v-if="selectedAmenity"
		          :items="operands"
		          item-text="label"
		          item-value="value"
		          label="Select Operand"
		          outline
		          :disabled="selectedAmenity.dataType=='Allowed Values' ||  selectedAmenity.dataType=='Boolean'"
		          v-model="selectedOperand">
		          	
		        </v-select>	

		        <v-select v-if="selectedAmenity && selectedAmenity.dataType=='Boolean'"
		          :items="[{label: 'True', value: '1'}, {label: 'False', value: '0'}]"
		          item-text="label"
		          item-value="value"
		          label="Select True/False"
		          outline
		          v-model="selectedSearchValue">
		        </v-select>
		        <v-select v-if="selectedAmenity && selectedAmenity.dataType == 'Allowed Values'"
					v-model="selectedSearchValue" 
					label="Select Value"
					:items="selectedAmenity.allowedValues.map((item) => item.value )"
					@input="changed = true"
					outline>
				</v-select>
		        <v-text-field v-if="selectedAmenity && ( selectedAmenity.dataType!='Boolean' && selectedAmenity.dataType!='Allowed Values') "
		          label="Enter Value"
		          :rules="rules(selectedAmenity.dataType)"
		          autofocus
		          outline
		          return-object
		          v-model="selectedSearchValue">
		        </v-text-field>	
	        </v-form>	
	        <v-btn v-if="selectedAmenity && selectedSearchValue" @click="addToSearchAmenities" dark color="blue darken-3">
	        	Add to Search</v-btn>
	        <v-btn v-if="selectedAttribute && selectedSearchValue" @click="addToSearchAttributes" dark color="blue darken-3">
	        	Add to Search</v-btn>	
	        
	        <div v-if="searchAmenities || searchAttributes" class="pt-2" >
	        	<v-flex class="caption mb-1" style="color: grey;">Search Criteria</v-flex>
	        	<v-layout class="ml-2" row v-for="(item, index) in searchAttributes " :key="index" justify-space-between>
	        		<v-flex xs5>{{item.label}}</v-flex>
	        		<v-flex xs1>{{item.operand}}</v-flex>
	        		<v-flex xs5 class="text-xs-right mr-2">{{formatValue(item)}}</v-flex>
	        		<v-tooltip top>
	        		<v-flex xs1 slot="activator"><v-icon small color="red lighten-2" 
	        			@click="removeSearchAttribute(index)">close</v-icon>
	        		</v-flex>
	        		Clear
	        		</v-tooltip>
	        	</v-layout>	
	        	<v-layout class="ml-2" row v-for="(item, index) in searchAmenities" :key="index+100" justify-space-between>
	        		<v-flex xs5>{{item.label}}</v-flex>
	        		<v-flex xs1>{{item.operand}}</v-flex>
	        		<v-flex xs5 class="text-xs-right mr-2">{{formatValue(item)}}</v-flex>
	        		<v-tooltip top>
	        		<v-flex xs1 slot="activator"><v-icon small color="red lighten-2" 
	        			@click="removeSearchAmenity(index)">close</v-icon>
	        		</v-flex>
	        		Clear
	        		</v-tooltip>
	        	</v-layout>	        	
	        </div>
	        <v-alert :value="loading" type="info" class="ml-2 mt-3">Loading...</v-alert>
	        <v-btn v-if="searchPayload && !loading" class="ml-0 mt-3" color="#a70000" dark @click="submitSearch">Search</v-btn>
        </v-card-text>
        <div style="position: absolute; bottom: 10px; right: 10px;">
        	<v-tooltip top>
        		<v-btn slot="activator" icon small style="transform: scale(.9);"><v-icon @click="showHelp">help</v-icon></v-btn>
        		<span>Search Help</span>
        	</v-tooltip>
        </div><br><br>
    </v-card>
    <HelpRoomAttributeSearch />
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import AutocompleteCollege from '@/components/forms/AutocompleteCollege'
import AutocompleteDepartment from '@/components/forms/AutocompleteDepartment'
import HelpRoomAttributeSearch from '@/components/help/HelpRoomAttributeSearch'

export default {
data () {
	return {	listOfLists: 	[{listname: 'Loading...'}],
				listDefinition: null,
				selectedList: 	null,
				selectedAmenity: null,
				selectedOperand: '=',
				selectedSearchValue: null,
				searchAmenities: null,
				searchAttributes: null,
				searchPayload: null,
				valid: false,
				loading: false,
				selectedAttribute: null,
				operands: [ { label: 'EQUALS', 				value: '='  }, 
							{ label: 'IS GREATER THAN',		value: '>'  },
							{ label: 'IS LESS THAN',		value: '<'  }, 
						  ],

			    conditions: 	[ 'Fair', 'Good', 'Poor'	 					],
			    suitabilities: 	[ 'Aligned', 'Misaligned', 'Not aligned'		],
			    utilizations: 	[ 'High', 'Low', 'Vacant'					    ],

			    roomAttributes: [				    
				    { label: "Area", 			attribute: "area", 			 value: null, operands: true },
				    { label: "Name", 			attribute: "name", 			 value: null, },
				    { label: "College", 		attribute: "collegeID", 	 value: null },
				    { label: "Department",	 	attribute: "deptID", 		 value: null },
				    { label: "Category", 		attribute: "category", 		 value: null },
				    { label: "Type", 			attribute: "type", 			 value: null },
				    { label: "Use", 			attribute: "use", 			 value: null },
				    { label: "Capacity", 		attribute: "capacity", 		 value: null, operands: true },
				    { label: "TempCapacity", 	attribute: "tempCapacity", 	 value: null, operands: true },
				    { label: "Building",  	 	attribute: "bldgAlpha", 	 value: null },
				    { label: "Floor", 		 	attribute: "floor", 		 value: null, operands: true },
				    { label: "Classification", 	attribute: "classification", value: null },
				    { label: "Utilization", 	attribute: "utilization", 	 value: null },
				    { label: "Suitability", 	attribute: "suitability", 	 value: null },
				    { label: "Condition", 		attribute: "condition", 	 value: null },
				]
								

	}
},

components: { AutocompleteCollege, AutocompleteDepartment, HelpRoomAttributeSearch },

created: async function () {
	this.listOfLists = await this.fetchAmenitiesListOfLists()
},

computed: {
	...mapState({   	buildings: state => state.space.buildings,
						categories: state => state.lists.categories,
						uses:       state => state.lists.uses,
						types: 		state => state.lists.types, 
						classifications: state => state.lists.classifications,
                		roomNames:  state => state.lists.roomNames,
                		darkTheme:  state => state.ui.darkTheme,
				})
},

methods : {
	...mapMutations([ 	'setSearchResults',
                        'setLoading',
                        'setSearchTitle',
                        'setSearchSubtitle',
                        'updateSearchResultSidebar',
                        'updateMainSidebar',
                        'setSnackText',
                        'setShowHelpRoomAmenities',
                        'setSearchExportText',
                        'setMainMenuIsTemporary',
                        'setShowHelpRoomAttributeSearch',

					]),
	...mapActions([		'fetchAmenitiesListOfLists', 'fetchAmenitiesList', 
						'fetchSearchRoomAmenities', 'fetchSearchRoomsMultiAttribute', 
				  ]),
	
	rules: function (dataType) {
		if (dataType=='Boolean') { 
			return [ v => !!v || "Field is required", ] 
		}
		if (dataType=='Number') { 
			return [ v => !isNaN(v) || !v || 'Must be a number.', ] 
		}
		if (dataType=='Integer') { 
			return [ v => this.isInteger(v) || !v || 'Must be an Integer.', ] 
		}
		if (dataType=='Date') { 
			return [ v => this.isDate(v) || !v || 'Must be a Date. MM/DD/YYYY', ] 
		}
	},

	showHelp: function () {
		this.setMainMenuIsTemporary(false)
		this.setShowHelpRoomAttributeSearch(true)
	},

	isInteger: function (str) {
	    var n = Math.floor(Number(str));
	    return n !== Infinity && String(n) === str && n >= 0;
	},

	isDate: function (str) {
		return moment(str, "MM/DD/YYYY", true).isValid()
	},

	listChanged: async function () {
		if (!this.selectedList) { return }
		this.listDefinition = await this.fetchAmenitiesList({ key: this.selectedList.key })
	},

	addToSearchAttributes: function () {
		//if (!this.valid) { console.log("Form Not Valid"); return }
		if (!this.searchAttributes) { this.searchAttributes = [] }

		/*if (this.searchAttributes.find((row) => {return row.label === this.selectedAttribute.label })) {
			this.setSnackText("Duplicate Attribute in Search")
			return 
		}*/
		this.searchAttributes.push({ 	'label':  		this.selectedAttribute.label,
										'operand':   	this.selectedOperand, 
										'attribute':    this.selectedAttribute.attribute,
										'value': 		this.selectedSearchValue,  })
		// Update Payload
		if (!this.searchPayload) { this.searchPayload = { amenities: [], attributes: [] } }	// Initialize if null
		this.searchPayload.attributes = this.searchAttributes

		// Clear things
		this.selectedSearchValue = null
		this.selectedAttribute = null
		this.selectedOperand = "="
	},

	addToSearchAmenities: function () {
		if (!this.valid) { console.log("Form Not Valid"); return }
		if (!this.searchAmenities) { this.searchAmenities = [] }
		if (this.searchAmenities.find((row) => {return row.amenitykey === this.selectedAmenity.key })) {
			this.setSnackText("Duplicate Amenity in Search")
			return 
		}
		this.searchAmenities.push({ 	
							'amenitykey': 	this.selectedAmenity.key,
							'label':  		this.selectedAmenity.label,
							'operand':   	this.selectedOperand, 
							'dataType':		this.selectedAmenity.dataType,
							'value': 		this.selectedSearchValue,
		})

		// Update Payload
		if (!this.searchPayload) { this.searchPayload = { amenities: [], attributes: [] } }	// Initialize if null
		this.searchPayload.amenities = this.searchAmenities
		
		//Clear things
		this.selectedSearchValue = null
		this.selectedAmenity = null
		this.selectedOperand = "="
	},

	formatValue: function (item) {
		if (item.dataType=="Boolean") {
			return item.value == '1' ? 'True' : 'False'
		}
		return item.value
	},

	queryText: function (searchPayload) {
		console.log("searchPayload: ", searchPayload)
		let niceText = ""
		searchPayload.amenities.forEach((row) => {
			niceText += `${row.label} ${row.operand} ${this.formatValue(row)}` + "<br>"
		})
		searchPayload.attributes.forEach((row) => {
			niceText += `${row.label} ${row.operand} ${this.formatValue(row)}` + "<br>"
		})
		console.log("niceText: ", niceText)
        return niceText
    },

    collegeAutoCompleteReturn (value) {
    	this.selectedSearchValue = value.id
    },

    departmentAutoCompleteReturn (value) {
    	this.selectedSearchValue = value.deptID
    },

    removeSearchAttribute (index) {
    	this.searchAttributes.splice(index,1)
    	if (this.searchPayload.amenities.length == 0 && this.searchPayload.attributes.length == 0) { 
    		this.searchPayload = null
    	}
    	if (this.searchAttributes.length == 0) { this.searchAttributes = null }
    },

	removeSearchAmenity (index) {
    	this.searchAmenities.splice(index,1)
    	if (this.searchPayload.amenities.length == 0 && this.searchPayload.attributes.length == 0) { 
    		this.searchPayload = null
    	}
    	if (this.searchAmenities.length == 0) { this.searchAttributes = null }
    },

	submitSearch() {	
		console.log(JSON.stringify(this.searchPayload))
		this.loading = true	
		this.setLoading(true)
        this.fetchSearchRoomsMultiAttribute(this.searchPayload).then((data) => {
            if (!data || data == "No Rooms Found") {
                this.setSnackText("No Results Found");  
                this.setLoading(false)
                this.loading=false
                return
            }

            this.loading=false

            // Collapse smaller sites into one site "Other Sites"
                
                let newData = JSON.parse(JSON.stringify(data)) // Deep Copy
                newData.sites = []
                let otherBuildings = []

                data.sites.forEach((site) => {
                    
                    // if this site is not Main, Phx, or South, collect all the buildings together into an array.
                    if (site.siteID != '10' && site.siteID != '19' && site.siteID != '108') {
                        site.buildings.forEach((bldg) => {
                            otherBuildings.push(bldg)
                        })                         
                    } else { 
                        // else just push this site into the return (newData) whole                           
                        newData.sites.push(site)
                    }
                })

                // Build the "Other" site
                if (otherBuildings.length > 0) {
                    newData.sites.push({'siteID': 'Other', 'siteName': 'Other Sites', 'buildings': otherBuildings})
                }

            
            this.setSearchResults(newData) 

            //this.setSearchResults(data)    // Using this instead will detail out each individual site
            //this.updateMainSidebar(false)                   

            
            /*${this.queryText(this.search)}*/
            const subtitle =    `<div style="background-color: #30302E;color: white;padding: 25px;margin-left: -25px;
                                        margin-top: -25px;">
                                        <div class="headline">
                                        ${this.queryText(this.searchPayload)}
                                        </div>
                                        <div>Total Area: ${data.areaSum.toLocaleString()}</div>
                                        <div>Bldg Count: ${data.bldgCount.toLocaleString()}</div>
                                        <div>Room Count: ${data.roomCount.toLocaleString()}</div>

                                `

            this.setSearchTitle("Room Search")
            this.setSearchSubtitle(subtitle)              
            this.updateSearchResultSidebar(true)
            this.updateMainSidebar(false)
            this.setLoading(false)

            const regexBr 	= new RegExp('<br>', 'gi');
			let nicerText 	= this.queryText(this.searchPayload).replace(regexBr, ' & ');
			nicerText 		= nicerText.slice(0, -3) // take last two chars off
			this.setSearchExportText(nicerText) // Used 
        }) 
    }, 

    customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
        const bldgAlpha = item.bldgAlpha.toLowerCase()
        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
        					item.commonName + item.shortName + item.aliasName

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3 ) {
        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        } else {
        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
        }
    },

},
}

</script>

<style>
.amenitiesSearchToolbar .v-toolbar__content {
	padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/SearchRoomMulti.vue